// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-PasswordForgotForm__wrapper","form":"c-PasswordForgotForm__form","loading":"c-PasswordForgotForm__loading"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/PasswordForgotForm/PasswordForgotForm.scss
// module id = 730
// module chunks = 0